checkUserAvatar.$inject = ["$q"];

function checkUserAvatar($q) {
    return {
        restrict: 'A',
        scope: {
            replaceImage: '=',
        },
        link: function (scope, element, attrs) {
            attrs.$observe('ngSrc', function (ngSrc) {
                var deferred = $q.defer();
                var image = new Image();
                image.onerror = function () {
                    deferred.resolve(false);
                    element.attr('src', scope.replaceImage);
                };
                image.onload = function () {
                    deferred.resolve(true);
                };
                image.src = ngSrc;
                return deferred.promise;
            });
        }
    };

}

module.exports = ngModule => {
    ngModule.directive('checkUserAvatar', checkUserAvatar);
};